import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import SkillSource, {SkillCancellableSource} from 'sources/SkillSource';
import {Api} from 'sources/api';
import {ActionsBase} from '@store/@types/alt';
import Skill, {SkillId} from 'records/Skill';
import {List} from 'immutable';
import {Moment} from 'moment';
import {UserId} from 'records/User';
import {TeamId} from 'records/TeamId';
import {NoMethods} from '@store/@types/alt/Actions';

interface AsyncMethods {
  fetchAllByTeam(params: {team_id: TeamId}): Promise<List<Skill>>;
  fetchAllUsed(): Promise<List<Skill>>;
  fetchUsedByDate(start: Moment, end: Moment, filter: TeamId[] | UserId): Promise<List<Skill>>;

  // TODO types
  fetchAverage(skillId: SkillId, params: any): Promise<any>;
  fetchTeamTrend(params: any): Promise<any>;
  fetchUserTrend(params: any): Promise<any>;
}

class SkillActions extends ActionsBase<AsyncMethods, NoMethods>() {
  constructor() {
    super();
    this.generateActions(
      ...generateAsyncActions(
        'fetchAllByTeam',
        'fetchAllUsed',
        'fetchUsedByDate',
        'fetchAverage',
        'fetchTeamTrend',
        'fetchUserTrend'
      )
    );
  }

  fetchAllByTeam(params) {
    return dispatch => {
      dispatch();
      return SkillSource.fetchAllByTeam(params).then(
        skills => this.fetchAllByTeamSuccess([skills, params]),
        error => {
          this.fetchAllByTeamError(error);
          throw error;
        }
      );
    };
  }

  fetchUsedByDate(start, end, filter) {
    return dispatch => {
      dispatch();
      return SkillSource.fetchUsedByDate(start, end, filter).then(
        this.fetchUsedByDateSuccess,
        this.fetchUsedByDateError
      );
    };
  }

  fetchAverage(skillId, params) {
    return dispatch => {
      dispatch(skillId, params);
      return SkillSource.fetchAverage(skillId, params).then(
        score => this.fetchAverageSuccess(skillId, params, score),
        this.fetchAverageError
      );
    };
  }

  fetchTeamTrend(params) {
    return dispatch => {
      dispatch(params);
      return SkillSource.fetchTeamTrend(params).then(
        payload => this.fetchTeamTrendSuccess(payload),
        this.fetchTeamTrendError
      );
    };
  }

  fetchUserTrend(params) {
    return dispatch => {
      dispatch(params);
      // TODO make cancellable the default (make sure to catch the cancel error)
      return SkillCancellableSource.fetchUserTrend(params).then(
        payload => this.fetchUserTrendSuccess(payload),
        error => {
          if (!Api.isCancel(error)) this.fetchUserTrendError(error);
        }
      );
    };
  }

  fetchAllUsed() {
    return dispatch => {
      dispatch();
      return SkillSource.fetchAllUsed().then(this.fetchAllUsedSuccess, this.fetchAllUsedError);
    };
  }
}

export default alt.createActions<AsyncMethods, NoMethods>(SkillActions);
